import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from "src/app/core/services/requests.service";

@Injectable({
  providedIn: 'root'
})
export class CargueService {
// ENDPOINT = "http://localhost:8000/cartera/cuentasbloqueadas";
  requestsService: any;
ENDPOINT = getEndpoint('cuentaBloqueada');
constructor(private _http: HttpClient, private _http2: RequestsService) { }

transformEtiquetasToInsert(etiquetas: CargueV[]) {
  return etiquetas ? etiquetas.map((value, index) => {
    value["c_emp"] = getConnection();
    return value;
  }) : []
}

async cargue(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
  const url = `${this.ENDPOINT}/cargue_cuentas/${company}`;
const body = {
  valores: payload,  // convierte todo a string
  usuario: usuario
};

  
  return await this._http2.postLikeJSON(url, body);
}
async desbloquear(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
  const url = `${this.ENDPOINT}/desbloquear_cuentas/${company}`;
const body = {
  valores: payload,  // convierte todo a string
  usuario: usuario
};

  
  return await this._http2.postLikeJSON(url, body);
}
  async get_cuentas(company:string){
    const url = `${this.ENDPOINT}/cuentas/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
}

export class CargueV {
clave: string;
c_agr: string;
t_cre: string;
cue: string;
n_ori: string;
fue: string;
n_fue: string;
ven: string;
valor: string;
capital: string;
interes: string;
val_seguro: string;
interes_mgracias: string;
}
